window.trithouseCustom = {
  getQuickbuyContainer: function() {
    $('#mini-cart-section').on('click', '.evg-recommendation-inner .quickbuy-toggle', function(e) {
        if(window.innerWidth > 480){
            e.preventDefault();

            trithouseCustom.popupOpen();

            var $quickbuyCont = $(this).parents('.popup-container').next().children()
            var productUrl = $(this).attr('href');
            var $detailCont = $quickbuyCont.find('.inner');
            $detailCont.empty();
            // add spinner
            $detailCont.html('<div class="loading-spinner"></div>');
            // load in content
            var url = $(this).attr('href');
            loadQuickbuyContainer = $.get(url, function (response) {
                var $newDetail = $('<div>' + response + '</div>').find('.quickbuy-content');

                // convert to quickbuy content
                $newDetail.find('[src*="api.jquery-"]').remove();
                $newDetail.find('script[src*="jquery.min.js"]').remove();
                $newDetail.find('.more').attr('href', productUrl);
                $newDetail.find('.detail .title').wrapInner($('<a>').attr('href', productUrl));
                $newDetail.find('.show-gallery').removeClass('show-gallery');
                $newDetail.find('.not-in-quickbuy').remove();
                $newDetail.find('.only-in-quickbuy').removeClass('only-in-quickbuy');
                $newDetail.find('.sticky-content-container').removeClass('sticky-content-container');
                $newDetail.find('.store-availability-container').remove();
                $newDetail.find('[data-enable-history-state="true"]').attr('data-enable-history-state', 'false');

                $detailCont.html($newDetail);
                // dpb if present
                if (Shopify.PaymentButton && $quickbuyCont.find('.shopify-payment-button').length) {
                // resize after loading extra payment buttons
                var _f = null;
                _f = function f() {
                    document.removeEventListener('shopify:payment_button:loaded', _f);
                    $quickbuyCont.trigger('changedsize');
                };
                document.addEventListener('shopify:payment_button:loaded', _f);

                Shopify.PaymentButton.init();
                }


                function loadComponents(componentContainer) {
                $(componentContainer).closest('[data-components]').each(function () {
                    $(this).data('components').split(',').forEach(function (component) {
                    $(document).trigger('cc:component:load', [component, componentContainer]);
                    });
                });
                $(componentContainer).find('.cc-accordion').on('transitionend.qbLoadComponents', function () {
                    $(this).closest('.quickbuy-container').trigger('changedsize');
                });

                $(document).trigger('cc:component:load', ['custom-select', '.quickbuy-container']);
                }
                loadComponents($quickbuyCont); // 3
                theme.initAnimateOnScroll(); // 4
                $quickbuyCont.trigger('changedsize'); // 5
                theme.OptionManager.initProductOptions($quickbuyCont.find('.product-form'));
                theme.initProductGallery($quickbuyCont);
                trithouseCustom.popupLoaded($('.quickbuy-container'));

            });

            $('.mini-cart-quickbuy-overlay').addClass('show');
        }
    });

    $('#shopify-section-mini-cart .quickbuy-container .close-detail').click(function() {
        trithouseCustom.popupClose();
    });
    $('.mini-cart-quickbuy-overlay').click(function(e) {
        var $quickbuyContainer = $(this).find('.quickbuy-container');
         if (!$(e.target).is($quickbuyContainer) && $quickbuyContainer.has(e.target).length === 0) {
           trithouseCustom.popupClose();
         }
    });
    $('#shopify-section-mini-cart').on('click', '.inner #first-atc' , function() {
        trithouseCustom.popupClose();
    });
  },

  popupOpen: function() {
      var sessionData = {
          mainImgs_arr_main: typeof mainImgs_arr !== 'undefined' ? mainImgs_arr : null,
          variants_options_arr_main: typeof variants_options_arr !== 'undefined' ? variants_options_arr : null,
          productPurchaseList_main: typeof productPurchaseList !== 'undefined' ? productPurchaseList : null,
          pMediaId_main: typeof pMediaId !== 'undefined' ? pMediaId : null,
          option_values_1_main: typeof option_values_1 !== 'undefined' ? option_values_1 : null,
          option_values_2_main: typeof option_values_2 !== 'undefined' ? option_values_2 : null
      };

      for (var key in sessionData) {
          if (sessionData[key] !== null) {
              window[key] = sessionData[key];
              //sessionStorage.setItem(key, JSON.stringify(sessionData[key]));
          }
      }
  },

  popupLoaded: function($container){
    trithouseCustom.onQuickbuyPopuploaded($container, mainImgs_arr);
  },

  popupClose: function() {
      var $quickBuyOverlay = $('.mini-cart-quickbuy-overlay');
      if ($quickBuyOverlay.hasClass('show')) {
          $quickBuyOverlay.removeClass('show');
      }
      $quickBuyOverlay.find('.inner').empty();

      var sessionKeys = {
          mainImgs_arr_main: 'mainImgs_arr',
          variants_options_arr_main: 'variants_options_arr',
          productPurchaseList_main: 'productPurchaseList',
          option_values_1_main: 'option_values_1',
          option_values_2_main: 'option_values_2',
          pMediaId_main: 'pMediaId'
      };

      for (var key in sessionKeys) {
          if (window[key]) {
              window[sessionKeys[key]] = window[key];
              delete window[key];
          }
          /*
          if (sessionStorage.getItem(key)) {
              window[sessionKeys[key]] = JSON.parse(sessionStorage.getItem(key));
              sessionStorage.removeItem(key);
          }*/
      }

      if($('.section-main-product .product-detail .product-form').length) {
          $('.section-main-product .product-detail .product-form').removeClass('theme-init');
          theme.OptionManager.initProductOptions($('.section-main-product .product-detail .product-form'));
      }
  },

  initPhotoSwipeLightbox: function ($container, imgsArr) {
    if (!$container || !imgsArr) return;

    var lightbox = new PhotoSwipeLightbox({
      dataSource: imgsArr,
      pswpModule: PhotoSwipe,
      showHideAnimationType: 'zoom',
      bgOpacity: 1,
      arrowPrevSVG: '<svg class="pswp__icn" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>',
      arrowNextSVG: '<svg class="pswp__icn" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>',
      closeSVG: '<svg class="pswp__icn" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
    });

    lightbox.addFilter('thumbEl', function (thumbEl, data, index) {
      return thumbEl;
    });

    lightbox.addFilter('placeholderSrc', function (placeholderSrc, slide) {
      return placeholderSrc;
    });

    var videoPlugin = new window.PhotoSwipeVideoPlugin(lightbox, {});

    lightbox.init();

    $container.data('lightboxInstance', lightbox);

    $container.find('.mImgLightbox-trigger').each(function (index, el) {
      $(el).on('click', function (e) {
        e.preventDefault();
        lightbox.loadAndOpen(index);
      });
    });

    return lightbox;
  },

  destroyPhotoSwipeLightbox: function ($container) {
    var lightbox = $container.data('lightboxInstance');
    if (lightbox) {
      lightbox.destroy();
      $container.removeData('lightboxInstance');
    }
  },

  onQuickbuyPopuploaded: function ($container, imgsArr){
    if($container.length) {
      trithouseCustom.initPhotoSwipeLightbox($container, imgsArr);
    }
  },

  selectors: {
    loadedWishlistItems:  "wishlist_items",
    loadedWishlistId: 'wishlist_id',
    wishlistBtnContainer: '.wishlist-btn-container',
    wishlistBtns: '.wishlist-btn-container .update-wishlist',
    wishlistBtnImgEl: 'img.wishlist-btn',
    isAddBtn: '[class*="add"]',
    isRemoveBtn: '[class*="remove"]',
    activeWishlistBtn: 'img.wishlist-btn.active',
    addWishlistWrapper: '.added-wishlist-wrapper',
    closeBtn: '.added-wrapper-header .close-btn',
    confirmPending: '.added-wishlist-wrapper .pending',
    wishlistFoldersList: '.added-wishlist-wrapper ul.wishlistFolder-list',
    selectExistFolder: '.added-wishlist-wrapper .select-exist-wishlist',
    createNewWishlist: '.create-new-wishlist',
    inputNewWishlist: 'input#wishlistName',
    errorMeg: '.error',
    confirmCreateWishlist: '.create-new-wishlist .confirm-list',
    cancelCreateWishlist: '.create-new-wishlist .back',
    cancelWrapper: '.cancel-wishlist-wrapper',
    confirmedPopup: '.confirm-wishlist-wrapper',
    active: 'active',
    productPurchaseForm: 'form.product-purchase-form',
    originalSelector: 'select.original-selector',
    buyTogether: 'input#buyTogether',
    addonProductVariantsOptions: 'select#addon-product-variantsOptions',
    quickAddonProduct: '.quick-addon-product',
    addonProductTitleSpan: '.addon-product-title span',
    requestHeaders: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    addAction: "wishlist.session.add",
    removeAction: "wishlist.session.delete",
    addWishlistName: "wishlist.session.addName",
    addEndPoint:'https://wishlist.trit.com.au/wishlist/add',
    removeEndpoint: 'https://wishlist.trit.com.au/wishlist/remove',
    w_header_count: '.wishlist-header-icon .wishlist-items_count',
    mainProductImageVisible: '#main-image-gallery .slide.slick-active.slick-current img',
    mainWishlistContentEl: '.wishlist-content',
    mainWishlistTitle: '.pagetitle',
    renameBtn: '.wishlist-content .rename-folder',
    renameContainer: '.wishlist-title .popup-overlay',
    renamePopupContent: '.rename-wishlist-wrapper',
    renameInput: '.edit-new-wishlist #wishlistName',
    renameError: '.error',
    renameCloseBtn: '.wishlist-content .edit-wishlist-btns .back',
    renameCloseBtn2: '.wishlist-content .close-btn',
    renameConfirmBtn: '.wishlist-content .edit-wishlist-btns .confirm-list',
    activeItems: '.wishlist-item.active',
    w_input: ".create-new-wishlist #wishlistName",
    share_copy_container: ".share-wishlist-feature .popup-overlay",
    share_copy_close: ".share-wishlist-wrapper .close-btn",
    share_copy_wrapper: ".share-wishlist-wrapper",
    share_copy_btn: ".share-wishlist-wrapper .copy-link",
    share_copy_input: "input#share-link",
    share_copy_confirm: ".confirm-meg",
    createEndpoint: 'https://wishlist.trit.com.au/wishlist/create',
    createAction: 'wishlist.session.createWL',
    main_w_removeClose: ".wishlist-page .remove-popup-close",
    main_w_removeCancel: ".wishlist-page .cancel-remove",
    main_w_removePopup: ".wishlist-page-btns .remove-all-popup",
    main_w_removeOverlay: ".wishlist-page-btns .popup-overlay"
  },

  getWishlistData: function() {
    var loadedWishlistItems = localStorage.getItem(trithouseCustom.selectors.loadedWishlistItems);
    var loadedWishlistId = localStorage.getItem(trithouseCustom.selectors.loadedWishlistId);
    var $wishlistBtnImgs = $(this).closest(trithouseCustom.selectors.wishlistBtnContainer).find(trithouseCustom.selectors.wishlistBtnImgEl);
    var $addWishlistWrapper = $(this).closest(trithouseCustom.selectors.wishlistBtnContainer).find(trithouseCustom.selectors.addWishlistWrapper);
    var $confirmPending = $(this).closest(trithouseCustom.selectors.wishlistBtnContainer).find(trithouseCustom.selectors.confirmPending);
    var $errorMeg = $(this).closest(trithouseCustom.selectors.wishlistBtnContainer).find(trithouseCustom.selectors.errorMeg);
    var $selectExistWishlist = $(this).closest(trithouseCustom.selectors.wishlistBtnContainer).find(trithouseCustom.selectors.selectExistFolder);
    var $cancelWrapper = $(this).closest(trithouseCustom.selectors.wishlistBtnContainer).find(trithouseCustom.selectors.cancelWrapper);
    var $confirmedPopup = $(this).closest(trithouseCustom.selectors.wishlistBtnContainer).find(trithouseCustom.selectors.confirmedPopup);
    var $createWishlist = $(this).closest(trithouseCustom.selectors.addWishlistWrapper).find(trithouseCustom.selectors.createNewWishlist);
    var $currentMainProductForm = $(this).closest(trithouseCustom.selectors.productPurchaseForm);
    var productIdCurrentPage = $currentMainProductForm.attr('data-product-id');
    var selectedVariantOnPage = $currentMainProductForm.find(trithouseCustom.selectors.originalSelector).val();

    return {
      loadedWishlistItems,
      loadedWishlistId,
      $wishlistBtnImgs,
      $addWishlistWrapper,
      $confirmPending,
      $errorMeg,
      $selectExistWishlist,
      $cancelWrapper,
      $confirmedPopup,
      $createWishlist,
      $currentMainProductForm,
      productIdCurrentPage,
      selectedVariantOnPage
    };
  },

  getCustomerList: function(){

    var customerEmail = "";
    var customerId = "";

    if(window.customerData){
      customerEmail = window.customerData.email?.email ?? "";
      customerId = window.customerData.id ?.id ?? "";
    }
    var customerList = {
      "customerEmail": customerEmail,
      "customerId": customerId,
    };
    return customerList
  },

  update_w_folder: async function(wId, variantsList, wishlistName, action) {
    var currentCustomerList = trithouseCustom.getCustomerList();
    var updatePayload = {
      "type": action,
      "wishlist_name": wishlistName,
      "variantsList": variantsList,
      "wishlist_id": wId,
      "customer_email": currentCustomerList.customerEmail,
      "customer_id": currentCustomerList.customerId
    };
    var updateWishlistNameResp = await trithouseCustom.updatelist(trithouseCustom.selectors.addEndPoint, JSON.stringify(updatePayload));
    if (updateWishlistNameResp != 1) {
      console.log('error', updateWishlistNameResp);
    }
    return updateWishlistNameResp;
  },

  updatelist: async function(url, payload) {
    const requestData = {
      "method": "post",
      "headers": trithouseCustom.selectors.requestHeaders,
      "body": payload
    };
    const wishlistUpdateResp = await fetch(url, requestData);
    if (wishlistUpdateResp.ok) {
      return 1;
    } else {
      return typeof wishlistUpdateRespJson !== 'undefined' ? wishlistUpdateRespJson : 0;
    }
  },

  addItem_w: async function(localItems, itemsCurrentPage, updateAction, wishlistId) {
    var currentWishlist_count = ($(trithouseCustom.selectors.w_header_count).html() > 0 )? parseFloat($(trithouseCustom.selectors.w_header_count).html()):0;
    var addedlist = [];
    //push the item to the wishlist localStorage
    if(localItems && localItems.length > 0){
      addedlist = JSON.parse(localItems);

      for(var i = 0; i < itemsCurrentPage.length; i++){
        var hasThisItem = addedlist.some((item) => item.variant_id == itemsCurrentPage[i].variant_id);
        if(!hasThisItem){
          addedlist = addedlist.concat(itemsCurrentPage[i]);
        }
        currentWishlist_count += 1;
      };
    }else{
      addedlist = itemsCurrentPage;
    }
    localStorage.setItem(trithouseCustom.selectors.loadedWishlistItems,JSON.stringify(addedlist));

    //update the count on the header
    trithouseCustom.update_w_header(currentWishlist_count);
    var currentCustomerList = trithouseCustom.getCustomerList();
    //update the wishlist
    var updatedWishlistResult = await trithouseCustom.postWishlist(currentCustomerList, wishlistId, itemsCurrentPage, updateAction);
  },

  removeItem_w: async function(localItems, itemsCurrentPage, updateAction, wishlistId) {
    var currentWishlist_count = ($(trithouseCustom.selectors.w_header_count).html() > 0 )? parseFloat($(trithouseCustom.selectors.w_header_count).html()):0;
    var removedItemFromlist = [];
    //push the item to the wishlist localStorage
    if(localItems && localItems.length > 0){
      removedItemFromlist = JSON.parse(localItems);
      for(var i = 0; i < itemsCurrentPage.length; i++){
        var hasThisItem = removedItemFromlist.some((item) => item.variant_id == itemsCurrentPage[i].remove);
        if(hasThisItem){
          removedItemFromlist = removedItemFromlist.filter((item) => item.variant_id != itemsCurrentPage[i].remove );
        }
        currentWishlist_count -= 1;
      };
      localStorage.setItem(trithouseCustom.selectors.loadedWishlistItems,JSON.stringify(removedItemFromlist));
    }
    //update the count on the header
    trithouseCustom.update_w_header(currentWishlist_count);
    var currentCustomerList = trithouseCustom.getCustomerList();
    //update the wishlist
    var updatedWishlistResult = await trithouseCustom.postWishlist(currentCustomerList, wishlistId, itemsCurrentPage, updateAction);
  },

  postWishlist: async function(customerList, wId, items, action) {
    var updatePayload = {
      "type": action,
      "items": items,
      "customer_email": customerList.customerEmail,
      "customer_id": customerList.customerId,
      "wishlist_id": wId
    };
    if(action == trithouseCustom.selectors.addAction){
      var listResp = await trithouseCustom.updatelist(trithouseCustom.selectors.addEndPoint, JSON.stringify(updatePayload));
    }else{
      var listResp = await trithouseCustom.updatelist(trithouseCustom.selectors.removeEndpoint, JSON.stringify(updatePayload));
    }

    if(listResp != 1){
      console.log('error',listResp);
    }
  },

  update_w_header: function(count) {
    $(trithouseCustom.selectors.w_header_count).html(count);
    if(count >= 1){
      trithouseCustom.activateEl($(trithouseCustom.selectors.w_header_count));
    }else{
      trithouseCustom.hideEl($(trithouseCustom.selectors.w_header_count));
    }
  },

  activateEl: function(el) {
    el.addClass(trithouseCustom.selectors.active);
  },

  hideEl: function(el) {
    el.removeClass(trithouseCustom.selectors.active);
  },

  createNewWishlist: async function() {
    const customer_list = trithouseCustom.getCustomerList();
    const payload = {
      "type": trithouseCustom.selectors.createAction,
      "customer_email": customer_list.customerEmail,
      "customer_id": customer_list.customerId
    };
    const w_ReqData = {
      "method": "POST",
      "headers": w_headerSelectors.requestHeaders,
      "body": JSON.stringify(payload)
    }
    const wishlistCreateResp = await fetch(trithouseCustom.selectors.createEndpoint, w_ReqData);
    if (wishlistCreateResp.ok) {
      const wishlistCreateRespJson = await wishlistCreateResp.json();
      return wishlistCreateRespJson.wishList_id;
    }else{
      return null
    }
  }
}

$(document).ready(function() {

  window.trithouseCustom.getQuickbuyContainer();

  $(trithouseCustom.selectors.wishlistBtns).on('click', async function(e) {
    e.preventDefault();
    var wishlistData = trithouseCustom.getWishlistData.call(this);
    trithouseCustom.hideEl(wishlistData.$createWishlist);
    trithouseCustom.hideEl(wishlistData.$selectExistWishlist);
    trithouseCustom.activateEl(wishlistData.$addWishlistWrapper);
    trithouseCustom.activateEl(wishlistData.$confirmPending);
    var isAddBtn = $(this).find(trithouseCustom.selectors.activeWishlistBtn).attr('class').includes('add');
    wishlistData.$wishlistBtnImgs.filter(trithouseCustom.selectors.isAddBtn).toggleClass(trithouseCustom.selectors.active, !isAddBtn);
    wishlistData.$wishlistBtnImgs.filter(trithouseCustom.selectors.isRemoveBtn).toggleClass(trithouseCustom.selectors.active, isAddBtn);
    var wishlistId = "";

    if(wishlistData.loadedWishlistId && wishlistData.loadedWishlistId.length >= 14){
      //14 is the wishlist-id default length
      wishlistId = wishlistData.loadedWishlistId;
    }else{
      wishlistId = await trithouseCustom.createNewWishlist();
      if(wishlistId){
        localStorage.setItem(trithouseCustom.selectors.loadedWishlistId, wishlistId);
      }
    }
    var itemsCurrentPage = [];
    var updateAction = "";
    if(isAddBtn){
      //add item
      updateAction = trithouseCustom.selectors.addAction;
      if (typeof variants_options_arr != 'undefined') {
        var selectedItemObj = variants_options_arr.find((v) => v.variantId == wishlistData.selectedVariantOnPage);
        var currentVisibleProductImage = document.querySelector(trithouseCustom.selectors.mainProductImageVisible).src;
        var variantImgSrc = ((selectedItemObj.variantImgSrc).indexOf('no-image') > -1 )? currentVisibleProductImage:selectedItemObj.variantImgSrc;
        var selectedProductVariantObj = {
          "product_link": selectedItemObj.variantLink,
          "product_image": variantImgSrc,
          "currency": "AUD",
          "product_price": selectedItemObj.variantPrice,
          "product_id": wishlistData.productIdCurrentPage,
          "variant_id": wishlistData.selectedVariantOnPage,
          "product_name": selectedItemObj.variantTitle,
          "sku": selectedItemObj.sku,
          "wishlist_name": ""
        };
        itemsCurrentPage.push(selectedProductVariantObj);
      }

      var addItemToList = await trithouseCustom.addItem_w(wishlistData.loadedWishlistItems, itemsCurrentPage, updateAction, wishlistId);

      //show confirmation message
      trithouseCustom.hideEl(wishlistData.$confirmPending);
      trithouseCustom.activateEl(wishlistData.$selectExistWishlist);
    } else {

      //remove item
      updateAction = trithouseCustom.selectors.removeAction;
      var selectedProductVariantObj = {
        "remove": wishlistData.selectedVariantOnPage
      };
      itemsCurrentPage.push(selectedProductVariantObj);

      //push the item to the wishlist localStorage
      if(wishlistData.loadedWishlistItems && wishlistData.loadedWishlistItems.length > 0){
        var loadedWishlistItemsJSON = JSON.parse(wishlistData.loadedWishlistItems);
        var hasThisItem = loadedWishlistItemsJSON.some((item) => item.variant_id == wishlistData.selectedVariantOnPage);
        if(hasThisItem){
          var removedItemFromlist = loadedWishlistItemsJSON.filter((item) => item.variant_id != wishlistData.selectedVariantOnPage );
          localStorage.setItem(trithouseCustom.selectors.loadedWishlistItems,JSON.stringify(removedItemFromlist));
        }
      }

      //show cancellation message
      trithouseCustom.hideEl(wishlistData.$addWishlistWrapper);
      trithouseCustom.hideEl(wishlistData.$selectExistWishlist);
      trithouseCustom.activateEl(wishlistData.$cancelWrapper);
      //hide the cancellation message automatically
      setTimeout(function(){
        trithouseCustom.hideEl(wishlistData.$cancelWrapper);
      },2000);
      var removeItemFromList = await trithouseCustom.removeItem_w(wishlistData.loadedWishlistItems, itemsCurrentPage, updateAction, wishlistId);
    };
  });

  $(trithouseCustom.selectors.wishlistFoldersList).on('click', 'li', async function(){
    var targetWishlistFolder = $(this).html();
    var target_w_index = parseFloat($(this).attr('value'));
    var updateAction = trithouseCustom.selectors.addWishlistName;
    var wishlistData = trithouseCustom.getWishlistData.call(this);;
    if(target_w_index == 0){
      trithouseCustom.hideEl(wishlistData.$selectExistWishlist);
      trithouseCustom.activateEl(wishlistData.$createWishlist);
    }else{
      trithouseCustom.activateEl($(this));
      wishlistData.$confirmedPopup.html( `<span>Added to <a href="https://www.trithouse.com.au/pages/wishlist">${targetWishlistFolder}</a></span>`);
      //hide confirmation box after adding the wishlist name
      trithouseCustom.hideEl(wishlistData.$addWishlistWrapper);
      trithouseCustom.hideEl($(this));
      trithouseCustom.activateEl(wishlistData.$confirmedPopup);
      var variantsList = (wishlistData.selectedVariantOnPage) ? [wishlistData.selectedVariantOnPage]:[];
      var updatedWishlistName = await trithouseCustom.update_w_folder(wishlistData.loadedWishlistId, variantsList, targetWishlistFolder,updateAction);
      if(updatedWishlistName == 1){
        //hide the confirmation message automatically
        setTimeout(function(){
          trithouseCustom.hideEl(wishlistData.$confirmedPopup);
        },2000);
        //update localStorage item wishlist name
        let localWishItems = JSON.parse(wishlistData.loadedWishlistItems);
        let localWishItemIndex = localWishItems.findIndex(item => item.variant_id == wishlistData.selectedVariantOnPage);
        if(localWishItemIndex > -1){
          localWishItems[localWishItemIndex].wishlist_name = targetWishlistFolder;
          localStorage.setItem(trithouseCustom.selectors.loadedWishlistItems,JSON.stringify(localWishItems));
        }
      }else{
        //show error message
        //trithouseCustom.activateEl(wishlistData.$errorMeg);
        console.log('Error: Failed to add item to wishlist folder');
      }
    }
  });

  $(trithouseCustom.selectors.confirmCreateWishlist).on('click', async function(e){
    e.preventDefault();
    var inputWishlistValue = $(this).closest(trithouseCustom.selectors.createNewWishlist).find(trithouseCustom.selectors.inputNewWishlist).val();
    var wishlistData = trithouseCustom.getWishlistData.call(this);;
    var updateAction = trithouseCustom.selectors.addWishlistName;
    var variantsList = (wishlistData.selectedVariantOnPage) ? [wishlistData.selectedVariantOnPage]:[];
    //hide confirmation box after adding the wishlist name
    trithouseCustom.hideEl(wishlistData.$addWishlistWrapper);
    wishlistData.$confirmedPopup.html( `<span>Added to <a href="https://www.trithouse.com.au/pages/wishlist">${inputWishlistValue}</a></span>`);
    trithouseCustom.activateEl(wishlistData.$confirmedPopup);
    var updatedWishlistName = await trithouseCustom.update_w_folder(wishlistData.loadedWishlistId, variantsList, inputWishlistValue,updateAction);
    if(updatedWishlistName == 1){
      //hide the confirmation message automatically
      setTimeout(function(){
        trithouseCustom.hideEl(wishlistData.$confirmedPopup);
      },2000);
      //update localStorage item wishlist name
      let localWishItems = JSON.parse(wishlistData.loadedWishlistItems);
      let localWishItemIndex = localWishItems.findIndex(item => item.variant_id == wishlistData.selectedVariantOnPage);
      if(localWishItemIndex > -1){
        localWishItems[localWishItemIndex].wishlist_name = inputWishlistValue;
        localStorage.setItem(trithouseCustom.selectors.loadedWishlistItems,JSON.stringify(localWishItems));
      }
    }else{
      //show error message
      //trithouseCustom.activateEl(wishlistData.$errorMeg);
      console.log('Error: Failed to add item to wishlist folder');
    };
  });

  $(trithouseCustom.selectors.cancelCreateWishlist).on('click',function(){
    trithouseCustom.hideEl($(this).closest(trithouseCustom.selectors.addWishlistWrapper));
  });

  if($(trithouseCustom.selectors.addWishlistWrapper).length > 0){
    $(document).on('click', function(e){
      if($(trithouseCustom.selectors.addWishlistWrapper).hasClass(trithouseCustom.selectors.active) && $(e.target).closest(trithouseCustom.selectors.addWishlistWrapper).length == 0 && $(e.target).closest(trithouseCustom.selectors.wishlistBtnContainer).length == 0){
        trithouseCustom.hideEl($(trithouseCustom.selectors.createNewWishlist));
        trithouseCustom.hideEl($(trithouseCustom.selectors.addWishlistWrapper));
      }
    });
  };

  $(trithouseCustom.selectors.w_input).on('keydown', function(e){
    if(e.key === "Enter"){
      event.preventDefault();
      $(trithouseCustom.selectors.confirmCreateWishlist).click();
    }
  });

  $(trithouseCustom.selectors.closeBtn).on('click', function(){
    trithouseCustom.hideEl($(trithouseCustom.selectors.createNewWishlist));
    trithouseCustom.hideEl($(this).closest(trithouseCustom.selectors.addWishlistWrapper));
  });

  $(trithouseCustom.selectors.renameBtn).on('click', function(){
    var currentMainWishlistName = $(this).closest(trithouseCustom.selectors.mainWishlistContentEl).find(trithouseCustom.selectors.mainWishlistTitle).html();
    $(this).closest(trithouseCustom.selectors.mainWishlistContentEl).find(trithouseCustom.selectors.renameInput).val(currentMainWishlistName);
    trithouseCustom.activateEl($(this).closest(trithouseCustom.selectors.mainWishlistContentEl).find(trithouseCustom.selectors.renameContainer));
  });

  $(trithouseCustom.selectors.renameConfirmBtn).on('click', async function(){
    var variantsList = [];
    var currentWishlistItems = $(this).closest(trithouseCustom.selectors.mainWishlistContentEl).find(trithouseCustom.selectors.activeItems);
    for(var i = 0; i < currentWishlistItems.length; i++){
      variantsList.push(currentWishlistItems[i].getAttribute('data-variant'));
    }
    var wishlistData = trithouseCustom.getWishlistData.call(this);
    var targetWishlistFolder = $(this).closest(trithouseCustom.selectors.mainWishlistContentEl).find(trithouseCustom.selectors.renameInput).val();
    var updateAction = trithouseCustom.selectors.addWishlistName;
    var updatedWishlistName = await trithouseCustom.update_w_folder(wishlistData.loadedWishlistId, variantsList, targetWishlistFolder,updateAction);
    if(updatedWishlistName == 1){
      //hide confirmation box after adding the wishlist name
      trithouseCustom.hideEl($(this).closest(trithouseCustom.selectors.renameContainer));
      //update localStorage item wishlist name
      let localWishItems = JSON.parse(wishlistData.loadedWishlistItems);
      for(var j = 0; j < variantsList.length; j++){
        let localWishItemIndex = localWishItems.findIndex(item => item.variant_id == variantsList[j]);
        if(localWishItemIndex > -1){
          localWishItems[localWishItemIndex].wishlist_name = targetWishlistFolder;
        }
      };
      localStorage.setItem(trithouseCustom.selectors.loadedWishlistItems,JSON.stringify(localWishItems));
      //reload the page and show the new title
      window.location.reload();
    }else{
      //show error message
      trithouseCustom.activateEl($(this).closest(trithouseCustom.selectors.renameContainer).find(trithouseCustom.selectors.removeError));
    }
  });

  $(trithouseCustom.selectors.renameInput).on('keydown', function(e){
    if(e.key === "Enter"){
      $(trithouseCustom.selectors.renameConfirmBtn).click();
    }
  })

  $(trithouseCustom.selectors.renameCloseBtn).on('click', function(){
    trithouseCustom.hideEl($(this).closest(trithouseCustom.selectors.renameContainer));
  });

  $(trithouseCustom.selectors.renameCloseBtn2).on('click', function(){
    trithouseCustom.hideEl($(this).closest(trithouseCustom.selectors.renameContainer));
  });

  $(trithouseCustom.selectors.renameContainer).on('click', function(e) {
    if (!e.target.closest(trithouseCustom.selectors.renamePopupContent)) {
      trithouseCustom.hideEl($(this));
    }
  });

  $(trithouseCustom.selectors.share_copy_btn).on('click', function(){
    const shareLink_value = $(this).parent().find(trithouseCustom.selectors.share_copy_input).val();
    const $share_confirmed = $(this).parent().find(trithouseCustom.selectors.share_copy_confirm);
    navigator.clipboard.writeText(shareLink_value).then(function(){
      trithouseCustom.activateEl($share_confirmed);
    })
  });

  $(trithouseCustom.selectors.share_copy_close).on('click', function(){
    trithouseCustom.hideEl($(this).closest(trithouseCustom.selectors.share_copy_container));
  });

  $(trithouseCustom.selectors.share_copy_container).on('click', function(e) {
    if (!e.target.closest(trithouseCustom.selectors.share_copy_wrapper)) {
      trithouseCustom.hideEl($(this));
    }
  });

  $(trithouseCustom.selectors.main_w_removeClose).on('click', function() {
    trithouseCustom.hideEl($(this).closest(trithouseCustom.selectors.main_w_removeOverlay));
  });

  $(trithouseCustom.selectors.main_w_removeCancel).on('click', function() {
    trithouseCustom.hideEl($(this).closest(trithouseCustom.selectors.main_w_removeOverlay));
  });

  $(trithouseCustom.selectors.main_w_removeOverlay).on('click', function(e) {
    if (!e.target.closest(trithouseCustom.selectors.main_w_removePopup)) {
      trithouseCustom.hideEl($(this));
    }
  })
});

if (typeof trithouseCustomCallback === 'function') {
  trithouseCustomCallback();
}
